import Ensemble from 'pages/inventory/components/options/ensemble';
import InventoryProductGrid from 'pages/inventory/components/options/InventoryproductGrid';
import Sommaire from 'pages/inventory/components/options/Sommaire';
import Vnl from 'pages/inventory/components/options/Vnl';

export const Tabs = [
  {
    key: 'Stats',
    params: (id) => `methode=lire&mode=stat&ptr=${id}&`,
    label: 'Statistique',
    dataKey: 'stat',
    component: InventoryProductGrid,
  },
  {
    key: 'Vnl',
    params: (id) => `methode=lire&mode=vnl&ptr=${id}&`,
    label: 'Vendu non livré',
    component: Vnl,
  },
  {
    key: 'Cmd',
    params: (id) => `methode=lire&mode=cmd&ptr=${id}&`,
    label: 'Commande',
    dataKey: 'cmd',
    component: InventoryProductGrid,
  },
  {
    key: 'Somm',
    params: (id) => `methode=lire&mode=entete&ptr=${id}&`,
    label: 'Sommaire',
    dataKey: 'sommaire',
    component: Sommaire,
  },
  {
    key: 'recept',
    params: (id) => `methode=lire&mode=recept&ptr=${id}&`,
    label: 'Reception',
    dataKey: 'recept',
    component: InventoryProductGrid,
  },
  {
    key: 'ensemble',
    params: (id) => `methode=lire&mode=entete&ptr=${id}&`,
    label: 'Ensemble',
    dataKey: 'ensemble',
    component: Ensemble,
  },
  {
    key: 'pub',
    params: (id) => `methode=lire&mode=pub&ptr=${id}&`,
    label: 'Publicité',
    dataKey: 'pub',
    component: InventoryProductGrid,
  }
];
